import { render } from "./move_folder.vue?vue&type=template&id=3274b0a4&scoped=true"
import script from "./move_folder.js?vue&type=script&lang=js"
export * from "./move_folder.js?vue&type=script&lang=js"

import "./move_folder.vue?vue&type=style&index=0&id=3274b0a4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3274b0a4"]])

export default __exports__